import { render } from "./AdminIslandPanel.vue?vue&type=template&id=7bdc13da"
import script from "./AdminIslandPanel.vue?vue&type=script&lang=js"
export * from "./AdminIslandPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__